import { Box, Typography, Stack } from '@mui/material'
import { C1Alert } from 'c1ui'
import { TaskViewLinkV2 } from 'components/core/task-list-v2/task-list-v2-components/TaskViewLinkV2'
import { TaskValue } from 'lib/actions/task'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type TaskWaitingOnProps = {
    waitingOnTasks: readonly TaskValue[]
}

export const TaskWaitingOn: FC<TaskWaitingOnProps> = ({ waitingOnTasks }) => (
    <Box>
        <C1Alert variant="banner" severity="info" icon={false} sx={{ flex: 1, overflow: 'visible', '& > *': { flex: 1 } }}>
            <Box p={2}>
                <Box mb={3}>
                    <Typography variant="h4" gutterBottom>
                        <FormattedMessage
                            id="components_task_details_waiting_on_tasks_title"
                            defaultMessage="Waiting on {count} {count, plural, one {task} other {tasks}} to complete..."
                            values={{ count: waitingOnTasks.length }}
                        />
                    </Typography>
                    <Typography>
                        <FormattedMessage
                            id="components_task_details_waiting_on_tasks_description"
                            defaultMessage="The following {count, plural, one {task} other {tasks}} must be completed before this task can be acted on."
                            values={{ count: waitingOnTasks.length }}
                        />
                    </Typography>
                </Box>

                <Stack spacing={2}>
                    {waitingOnTasks.map((waitingOnTask) => (
                        <Box component="span" key={waitingOnTask.id}>
                            <TaskViewLinkV2 task={waitingOnTask} />
                        </Box>
                    ))}
                </Stack>
            </Box>
        </C1Alert>
    </Box>
)
